import Bugsnag from "@bugsnag/js"

// Declare global window type
declare global {
  interface Window {
    Bugsnag: typeof Bugsnag
  }
}

const apiKey = process.env.BUGSNAG_API_KEY

// Get Rails environment from meta tag (set at runtime) instead of build-time env var
const getRailsEnv = (): string => {
  if (typeof document !== "undefined") {
    const metaTag = document.querySelector('meta[name="rails-env"]')
    if (metaTag) {
      return metaTag.getAttribute("content") || "development"
    }
  }
  return "development"
}

if (apiKey) {
  Bugsnag.start({
    apiKey,
    enabledReleaseStages: ["production", "staging"],
    releaseStage: getRailsEnv(),
    enabledErrorTypes: {
      unhandledExceptions: true,
      unhandledRejections: true,
    },
  })
}

// Expose Bugsnag globally for testing and manual error reporting
if (typeof window !== "undefined") {
  window.Bugsnag = Bugsnag
}

export default Bugsnag
